export const generateFileName = (name, id) => {
    const currentDate = new Date().toISOString().slice(0, 19).replace(/[-T:]/g, '')
    return `${currentDate}_${name}_${id}.pdf`;
}